import React from "react";
import {useTranslation} from "react-i18next";

import MDInput from "materialDashboard/components/MDInput";


const Model1Select = ({name, registry, formik, warnings={}, labelFn=r => `${r.code} - ${r.observation}`, onChange, ...props}) => {
    const {t} = useTranslation(['models1']);

    const changed = formik.values[name] !== formik.initialValues[name];

    return <MDInput select
                    SelectProps={{native: true}} // use native select to support select-by-typing and arrow select without opening menu
                    name={name}
                    label={t(`model1Form.${name}`)}
                    value={formik.values[name]}
                    onChange={onChange === undefined ? formik.handleChange : onChange}
                    error={formik.touched[name] && Boolean(formik.errors[name])}
                    helperText={formik.touched[name] && formik.errors[name] || (!changed && warnings[name])}
                    warning={!changed && Boolean(warnings[name])}
                    variant="standard"
                    fullWidth
                    {...props}>
        <option label=""></option>
        {
            registry.map((r) => <option key={r.code} value={r.code}>{labelFn(r)}</option>)
        }
    </MDInput>
}

export default Model1Select;